module.exports = __webpack_public_path__ + "img/business-manage-icon.10dd3196.png";